import { Grid, Group, useScrollIntoView } from '@ingeniorforeningen/figurine-core';
import { TFile, Errors } from '../../../types';
import File from './File';
import { useEffect } from 'react';

type FileListProps = {
  droppedFiles: TFile[] | undefined;
  removeFile: (id: string) => void;
  errorTexts: Errors;
  setAppendDocument: (fileUploadId: string, filename: string) => void;
  removeFileUploadId: (fileUploadId: string) => void;
};

const FileList = ({
  droppedFiles,
  removeFile,
  errorTexts,
  setAppendDocument,
  removeFileUploadId,
}: FileListProps) => {
  useEffect(() => {
    scrollIntoView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [droppedFiles?.length]);

  const {
    scrollIntoView,
    targetRef: scrollToTargetRef,
    scrollableRef,
  } = useScrollIntoView<HTMLDivElement>({
    duration: 100,
    axis: 'x',
  });

  return (
    <Group
      ref={scrollableRef}
      m={0}
      style={{
        position: 'relative',
        display: 'grid',
        overflowY: 'hidden',
        overflowX: 'auto',
        gridAutoFlow: 'column',
        gridTemplateRows: 'auto auto',
        gridAutoColumns: 'max(250px, 54%)',
        height: droppedFiles?.length ? 'auto' : 0,
      }}
      p={droppedFiles?.length ? 'md' : 0}
    >
      {droppedFiles &&
        droppedFiles.length > 0 &&
        droppedFiles.map((item, index) => {
          const isLastElement = droppedFiles.length === index + 1;
          return (
            <Grid item key={item.id} style={{ position: 'relative' }}>
              <File
                item={item}
                errorTexts={errorTexts}
                setAppendDocument={setAppendDocument}
                removeFileUploadId={removeFileUploadId}
                removeFile={removeFile}
              />
              {isLastElement && (
                <div
                  ref={scrollToTargetRef}
                  style={{ maxWidth: 0, position: 'absolute', right: 0 }}
                />
              )}
            </Grid>
          );
        })}
    </Group>
  );
};

export default FileList;
